import React from 'react'
import AuthShell from '~/src/components/auth/shell/AuthShell'
import {
  CardContent,
  CardFooterSlot,
  Foot,
} from '~/src/components/auth/shell/styles/authShell.styles'
import packageJson from '../../../../package.json'

interface IProps {
  customFooter?: React.ReactNode
  below?: React.ReactNode
  variant?: 'split' | 'centered'
  children: React.ReactNode
}

export default function SignInContainer({customFooter, below, variant, children}: IProps) {
  return (
    <AuthShell
      data-testid="sign-in-container"
      cardTestId="sign-in-paper"
      below={below}
      variant={variant}
      footer={
        <Foot data-testid="sign-in-footer">
          <span data-testid="sign-in-powered-by">Powered by Staffology</span>
          <span data-testid="sign-in-version-number">version {packageJson.version}</span>
        </Foot>
      }>
      <CardContent data-testid="sign-in-content">
        {children}
        {customFooter ? <CardFooterSlot>{customFooter}</CardFooterSlot> : null}
      </CardContent>
    </AuthShell>
  )
}
